import ToolbarDivider from "./ToolbarDivider";
import ToolbarRow from "./ToolbarRow";
import AlignToolbarGroup from "./groups/AlignToolbarGroup";
import HeadingsToolbarGroup from "./groups/HeadingsToolbarGroup";
import HistoryToolbarGroup from "./groups/HistoryToolbarGroup";
import InsertToolbarGroup from "./groups/InsertToolbarGroup";
import ListsToolbarGroup from "./groups/ListsToolbarGroup";
import TablesToolbarGroup from "./groups/TablesToolbarGroup";
import TextStylesToolbarGroup from "./groups/TextStylesToolbarGroup";

const ToolbarBase = () => {
  return (
    <ToolbarRow>
      <HistoryToolbarGroup />
      <ToolbarDivider />
      <TextStylesToolbarGroup />
      <ToolbarDivider />
      <ListsToolbarGroup />
      <ToolbarDivider />
      <AlignToolbarGroup />
      <ToolbarDivider />
      <HeadingsToolbarGroup />
      <ToolbarDivider />
      <TablesToolbarGroup />
      <ToolbarDivider />
      <InsertToolbarGroup />
    </ToolbarRow>
  );
};

export default ToolbarBase;
